export default "__VITE_ASSET__Cq1I5Bfk__"